import { ADD_STEP, REMOVE_STEP, DRESS_TOOL_API_CALL, DRESS_TOOL_INITIATE_FINAL_FLAG, DRESS_TOOL_INITIATE_INITIAL_FLAG, DRESS_TOOL_CLOSE_FLAG, START_ALL_STEPS, ATC_DRESS_TOOL_INITIATE, DRESS_TOOL_WITHOUT_FIRST } from "../../actions/shared/braRecommendation";

const initialStepsState = {
    dressToolStepsData: {
        currentStep: 0,
        perStepData: []
    }
};

const initialApiCallState = {
    dressToolApiCall:
    {}
}

const initialDressToolState = {                 //for displaying grid/final component(trigger)
    dressToolAggregateData: {
        initialStepsFlag: false,
        finalStepFlag: false,
        skipFirstStep: false,
        atcRecommendationStep: false,
        dataForFinalStep: []                    //data for final page
    }
};

export const stepsReducer = (state = initialStepsState, action) => {
    switch (action.type) {
        case 'ADD_STEP':
            return {
                ...state,
                dressToolStepsData: {
                    ...state.dressToolStepsData,
                    currentStep: state.dressToolStepsData.currentStep + 1,
                    perStepData: [...state.dressToolStepsData.perStepData, action.newItem]
                }
            };

        case 'REMOVE_STEP':
            return {
                ...state,
                dressToolStepsData: {
                    ...state.dressToolStepsData,
                    currentStep: state.dressToolStepsData.currentStep > 0
                        ? state.dressToolStepsData.currentStep - 1
                        : 0,
                    perStepData: state.dressToolStepsData.perStepData.slice(0, -1)
                }
            };

        case 'START_ALL_STEPS':
            return {
                ...state,
                dressToolStepsData: {
                    ...state.dressToolStepsData,
                    currentStep: 0,
                    perStepData: []
                }
            };

        default:
            return state;
    }
};


export const apiCallReducer = (state = initialApiCallState, action) => {
    switch (action.type) {
        case 'DRESS_TOOL_API_CALL':
            return {
                ...state,
                dressToolApiCall: action.apiCallData
            };
        default:
            return state;
    }
}


export const dressToolFlagReducer = (state = initialDressToolState, action) => {
    switch (action.type) {
        case 'DRESS_TOOL_INITIATE_INITIAL_FLAG':
            return {
                ...state,
                dressToolAggregateData: {
                    ...state.dressToolAggregateData,
                    initialStepsFlag: true,
                    finalStepFlag: false,
                    skipFirstStep: false,
                    atcRecommendationStep: false,
                    dataForFinalStep: [...state.dressToolAggregateData.dataForFinalStep]
                }
            };
        case 'DRESS_TOOL_INITIATE_FINAL_FLAG':
            return {
                ...state,
                dressToolAggregateData: {
                    ...state.dressToolAggregateData,
                    initialStepsFlag: false,
                    finalStepFlag: true,
                    skipFirstStep: false,
                    atcRecommendationStep: false,
                    dataForFinalStep: [action.dressToolData]
                }
            };
        case 'DRESS_TOOL_CLOSE_FLAG':
            return {
                ...state,
                dressToolAggregateData: {
                    ...state.dressToolAggregateData,
                    initialStepsFlag: false,
                    finalStepFlag: false,
                    skipFirstStep: false,
                    atcRecommendationStep: false,
                    dataForFinalStep: [...state.dressToolAggregateData.dataForFinalStep]
                }
            };
        case 'ATC_DRESS_TOOL_INITIATE':
            return {
                ...state,
                dressToolAggregateData: {
                    ...state.dressToolAggregateData,
                    initialStepsFlag: false,
                    finalStepFlag: false,
                    skipFirstStep: true,
                    atcRecommendationStep: true,
                    dataForFinalStep: [...state.dressToolAggregateData.dataForFinalStep]
                }
            };
        case 'DRESS_TOOL_WITHOUT_FIRST':
            return {
                ...state,
                dressToolAggregateData: {
                    ...state.dressToolAggregateData,
                    initialStepsFlag: false,
                    finalStepFlag: false,
                    skipFirstStep: true,
                    atcRecommendationStep: false,
                    dataForFinalStep: [...state.dressToolAggregateData.dataForFinalStep]
                }
            };
        default:
            return state;
    }
}
